import ColisportApi from '../services/api/colisport-api.service';

export const useColisportApi = (): ColisportApi => {
  return ColisportApi.getInstance();
};
